module.exports = require('./helpers/bundle-url').getBundleURL('4temp') + "Original.f51eff19.png";